/**
 * v101.188.0 · Motivos de cancelación (catálogo «Motivos de cierre y cancelación › Cancelación»).
 * Muestra los motivos activos para la actividad de la OT; si hay, son obligatorios (el backend también lo valida).
 * onChange(codes, required)
 */
import { useEffect, useState } from "react";
import api from "../lib/api";
import { Loader2 } from "lucide-react";

export default function CancelReasonPicker({ odooTaskId, value = [], onChange }) {
  const [opts, setOpts] = useState(null);
  const [required, setRequired] = useState(false);

  useEffect(() => {
    let alive = true;
    if (!odooTaskId) return undefined;
    api.get(`/v1/close-reasons/order/${odooTaskId}/cancel`)
      .then(({ data }) => {
        if (!alive) return;
        setOpts(data?.options || []);
        setRequired(!!data?.required);
        onChange?.(value, !!data?.required);
      })
      .catch(() => { if (alive) { setOpts([]); setRequired(false); } });
    return () => { alive = false; };
  }, [odooTaskId]); // eslint-disable-line react-hooks/exhaustive-deps

  if (opts === null) {
    return <div className="text-[11px] text-gray-400 flex items-center gap-1"><Loader2 size={11} className="animate-spin" /> Cargando motivos…</div>;
  }
  if (!opts.length) return null;
  const toggle = (code) => {
    const next = value.includes(code) ? value.filter((c) => c !== code) : [...value, code];
    onChange?.(next, required);
  };
  return (
    <div data-testid="cancel-reason-picker">
      <div className="text-xs font-semibold text-gray-600 mb-1">
        Motivo de la cancelación {required ? <span className="text-red-600">(obligatorio, uno o varios)</span> : "(opcional)"}
      </div>
      <div className="flex flex-wrap gap-1.5">
        {opts.map((o) => {
          const on = value.includes(o.code);
          return (
            <button key={o.code} type="button" onClick={() => toggle(o.code)} data-testid={`cancel-reason-${o.code}`}
              className={`px-2.5 py-1 rounded-full text-[11px] font-semibold border transition-colors ${on
                ? "bg-red-600 text-white border-red-600" : "bg-white text-gray-700 border-gray-300 hover:border-red-400"}`}>
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
